import { render, staticRenderFns } from "./TemplateStyleSettings.vue?vue&type=template&id=7f13214c"
import script from "./TemplateStyleSettings.vue?vue&type=script&lang=js"
export * from "./TemplateStyleSettings.vue?vue&type=script&lang=js"
import style0 from "./TemplateStyleSettings.vue?vue&type=style&index=0&id=7f13214c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports